import { RootState, SetState } from '@/store/useStore';
import type { ShowoffContext } from '@/features/Showoff/types';

const defaultShowoffState: ShowoffContext = {
  name: null,
  feature: null,
  currentStep: null,
};

export type ShowoffSlice = {
  showoffContext: ShowoffContext;
  setShowoffContext: (newContext: Partial<ShowoffContext>) => void;
  resetShowoffContext: () => void;
};

export const showoffSlice = ({ set }: SetState<RootState>): ShowoffSlice => ({
  showoffContext: { ...defaultShowoffState },
  setShowoffContext: (newContext: Partial<ShowoffContext>) =>
    set(
      (state: RootState) => ({
        ...state,
        showoffContext: { ...state.showoffContext, ...newContext },
      }),
      false,
      'showoff/setShowoffContext',
    ),
  resetShowoffContext: () =>
    set(
      () => ({ showoffContext: { ...defaultShowoffState } }),
      false,
      'showoff/resetShowoffContext',
    ),
});
